import axiosInstance from '../config/axios';

// Get parent profile by user ID
export const getParentProfile = async (userId) => {
  try {
    const response = await axiosInstance.get(`/parent/${userId}`);
    return response.data;
  } catch (error) {
    throw error.response?.data?.message || "Failed to fetch parent profile";
  }
};

// Update parent profile (with formData)
export const updateParentProfile = async (userId, formData) => {
  try {
    const response = await axiosInstance.post(`/parent/${userId}`, formData, {
      headers: { "Content-Type": "multipart/form-data" }
    });
    return response.data;
  } catch (error) {
    throw error.response?.data?.message || "Failed to update parent profile";
  }
};

// Get a single child profile
export const getChildProfile = async (childId) => {
  try {
    const response = await axiosInstance.get(`/child/${childId}`);
    return response.data;
  } catch (error) {
    throw error.response?.data?.message || "Failed to fetch child profile";
  }
};

// Add new child profile
export const addChildProfile = async (formData) => {
  try {
    const response = await axiosInstance.post(`/child`, formData, {
      headers: { "Content-Type": "multipart/form-data" }
    });
    return response.data;
  } catch (error) {
    throw error.response?.data?.message || "Failed to add child profile";
  }
};

// Update child profile by ID
export const updateChildProfile = async (formData, id) => {
  try {
    const response = await axiosInstance.post(`/child/${id}`, formData, {
      headers: { "Content-Type": "multipart/form-data" }
    });
    return response.data;
  } catch (error) {
    throw error.response?.data?.message || "Failed to update child profile";
  }
};

// Get all children of a parent
export const getChildren = async (parentId) => {
  try {
    const response = await axiosInstance.get(`/parents/${parentId}/child`);
    return response.data;
  } catch (error) {
    throw error.response?.data?.message || "Failed to fetch children";
  }
};

// Delete a child by ID
export const deleteChild = async (childId) => {
  try {
    const response = await axiosInstance.delete(`/child/${childId}`);
    return response.data;
  } catch (error) {
    throw error.response?.data?.message || "Failed to delete child";
  }
};

// Change Password
export const changePassword = async (formData) => {
  try {
    const response = await axiosInstance.post(`/change-password`, formData);
    return response.data;
  } catch (error) {
    throw error.response?.data?.message || "Failed";
  }
};

// Help Support
export const helpSupport = async (formData) => {
  try {
    const response = await axiosInstance.post(`/help-support/create`, formData);
    return response.data;
  } catch (error) {
    throw error.response?.data?.message || "Failed";
  }
};

// Resend Verification 
export const resendEmailVerfication = async (formData) => {
  try {
    const response = await axiosInstance.post(`/email/resend`, formData);
    return response.data;
  } catch (error) {
    throw error.response?.data?.message || "Failed";
  }
}